export default __webpack_public_path__ + "static/media/course-content-empty.e81597a7.svg";